import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'inArray'
})
export class InArrayPipe implements PipeTransform {

    transform(values: Array<any>, search: any): boolean {
        if (values.indexOf(search) !== -1) {
            return true;
        } else {
            return false;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/pipes/in-array.pipe.ts